import React from 'react';
import { Header } from './Header';
import { Navigation } from './Navigation';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div
      className="min-h-screen bg-dark"
      style={{
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      <Header />
      

      <main
        className="px-4 pb-28"
        style={{
          paddingTop: 'calc(64px + env(safe-area-inset-top))', // Header height + safe area
        }}
      >
        {children}
      </main>

      <Navigation />
    </div>
  );
}
